import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { submitionService } from './submition.service';
import { clearAlertWithDelay, setAlertError } from '../alert/alert.slice';

const initialState = {
  submition: {
    updating: false,
    loading: false,
    secureProcessLoading: false,
    manualrocessLoading: false,
  },
};

export const getSubmition = createAsyncThunk('/submition/get', async (submitionId, thunkAPI) => {
  const response = await submitionService.get(submitionId);

  return { data: response.data.submition };
});

export const createSubmition = createAsyncThunk(
  '/submition/create',
  async (submition, thunkAPI) => {
    try {
      const response = await submitionService.create(submition);
      return response.data;
    } catch (err) {
      thunkAPI.dispatch(
        setAlertError(
          'Your submission was unsuccessful, please check your internet connection and try again.'
        )
      );
      thunkAPI.dispatch(clearAlertWithDelay());
      return thunkAPI.rejectWithValue(err);
    }
  }
);

export const updateSubmition = createAsyncThunk(
  '/submition/update',
  async (submition, thunkAPI) => {
    try {
      const response = await submitionService.update(submition);
      return response.data;
    } catch (err) {
      console.log('ERROR', err);
      thunkAPI.dispatch(
        setAlertError(
          'Your submission was unsuccessful, please check your internet connection and try again.'
        )
      );
      thunkAPI.dispatch(clearAlertWithDelay());
      return thunkAPI.rejectWithValue(err);
    }
  }
);

export const fetchDocuments = createAsyncThunk(
  '/submition/fetchDocuments',
  async (clientId, thunkAPI) => {
    const response = await submitionService.getDocuments(clientId);
    return response.data;
  }
);

export const createManualProcess = createAsyncThunk(
  '/submition/manualProcess',
  async (submitionId, thunkAPI) => {
    try {
      const response = await submitionService.createManualProcess(submitionId);
      return response.data;
    } catch (err) {
      thunkAPI.dispatch(
        setAlertError(
          'Your submission was unsuccessful, please check your internet connection and try again.'
        )
      );
      thunkAPI.dispatch(clearAlertWithDelay());
      return thunkAPI.rejectWithValue(err);
    }
  }
);

export const createSecureProcess = createAsyncThunk(
  '/submition/secureProcess',
  async (submitionId, thunkAPI) => {
    try {
      const response = await submitionService.createSecureProcess(submitionId);
      return response.data;
    } catch (err) {
      console.log('ERROR', err);
      thunkAPI.dispatch(
        setAlertError(
          "Something went wrong, couldn't create secure process, please check your internet connection and try again."
        )
      );
      thunkAPI.dispatch(clearAlertWithDelay());
      return thunkAPI.rejectWithValue(err);
    }
  }
);

export const submitionSlice = createSlice({
  name: 'submition',
  initialState,
  reducers: {
    saveSubmition: (state, action) => {
      state.data = action.payload;
    },
    resetSubmition: (state, action) => {
      state.submition = initialState;
      state.data = {};
    },
  },
  extraReducers: {
    [getSubmition.fulfilled]: (state, action) => {
      state.submition.loading = false;
      state.data = action.payload.data;
    },
    [getSubmition.pending]: (state, action) => {
      state.submition.loading = false;
    },
    [createSubmition.fulfilled]: (state, action) => {
      state.submition = { loading: false, ...action.payload };
    },
    [createSubmition.pending]: (state, action) => {
      state.submition = { loading: true };
    },
    [createSubmition.rejected]: (state, action) => {
      state.submition = { loading: false, ...action.payload };
    },
    [updateSubmition.fulfilled]: (state, action) => {
      state.submition = { loading: false, updating: false, ...action.payload };
    },
    [updateSubmition.rejected]: (state, action) => {
      state.submition = { loading: false, updating: false, ...action.payload };
    },
    [updateSubmition.pending]: (state, action) => {
      state.submition = { updating: true, loading: true };
    },
    [fetchDocuments.fulfilled]: (state, action) => {
      state.submition.documents = action.payload;
      state.submition.loading = false;
    },
    [fetchDocuments.pending]: (state, action) => {
      state.submition.documents = [];
      state.submition.loading = true;
    },
    [createManualProcess.fulfilled]: (state, action) => {
      state.submition = { manualrocessLoading: false };
    },
    [createManualProcess.rejected]: (state, action) => {
      state.submition = { manualrocessLoading: false };
    },
    [createManualProcess.pending]: (state, action) => {
      state.submition = { manualrocessLoading: true };
    },
    [createSecureProcess.fulfilled]: (state, action) => {
      state.submition = { secureProcessLoading: false };
    },
    [createSecureProcess.rejected]: (state, action) => {
      state.submition = { secureProcessLoading: false };
    },
    [createSecureProcess.pending]: (state, action) => {
      state.submition = { secureProcessLoading: true };
    },
  },
});

export const { resetSubmition, saveSubmition } = submitionSlice.actions;

export default submitionSlice.reducer;
